import config from '../../../../../../config';

const sendDistrictMagicLinkEmail = (email, hasPaidAndSigned) => {
  const redirectPath = hasPaidAndSigned ? 'setup/school' : 'payment';

  return fetch(`${config.REACT_APP_API_BASE_URL}/auth/district/magic-link`, {
    method: 'POST',
    body: JSON.stringify({
      email,
      path: `/onboarding/${redirectPath}`,
    }),
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export default sendDistrictMagicLinkEmail;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/UserRegistration/utils/sendDistrictMagicLinkEmail.js